// componente per la creazione di un nuovo utente

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../service/api.service';

@Component({ templateUrl: 'register.component.html' })
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    loading = false;
    submitted = false;
    profs = ["Admin", "User", "SuperAdmin"];
    profile: string;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private userService: ApiService,
    ) {

    }

    // definizione validatori campi nella form
    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            systems: ['', Validators.required],
            username: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });
    }

    // metodo che imposta il nome del profilo
    addProfile(vs) {
        this.profile = vs
    }

    // metodo che restituisce le credenziali digitate dall'utente nell'apposito form di login
    get f() { return this.registerForm.controls; }

    // metodo richiamato al click del pulsante "Inserisci" (simile a onSubmit() di login.component.ts)
    onSubmit() {
        this.submitted = true;
        if (this.registerForm.invalid) {
            return;
        }
        this.loading = true;
        var me = this
        this.registerForm.value.profile = this.profile
        this.userService.register(this.registerForm.value)
            .subscribe(
                data => {
                    me.router.navigate(['users']);
                    this.loading = false;
                });
    }
}
